import { render } from "./HoldsList.vue?vue&type=template&id=c7613300&scoped=true"
import script from "./HoldsList.vue?vue&type=script&lang=js"
export * from "./HoldsList.vue?vue&type=script&lang=js"

import "./HoldsList.vue?vue&type=style&index=0&id=c7613300&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7613300"]])

export default __exports__